<template>
  <div class="config_main_manage_background">
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <config-hang v-if="$route.query.type === 'onLinechangeRemark' || $route.query.type === 'offLinechangeRemark'">
          <img slot="config_hang_input_img" src="~assets/img/config/hostname.png" alt />
          <input class="add_device_input" slot="config_hang_input_left" type="text" v-model="query.remark"
            placeholder="请输入设备备注" />
        </config-hang>

        <config-hang v-if="$route.query.type === 'onLinechangeAddress' || $route.query.type === 'offLinechangeAddress'">
          <img slot="config_hang_input_img" src="~assets/img/config/weiyima2.png" alt />
          <input slot="config_hang_input_left" type="text" v-model="query.address" placeholder="请输入设备地址" disabled />
        </config-hang>

        <div class="xiaotishi_style">产品类型码:{{ query.productCode }}</div>
        <div class="xiaotishi_style">产品信息码:{{ query.program }}</div>
        <div class="xiaotishi_style">当前地址:{{ query.address }}</div>

        <div v-if="$route.query.type === 'onLinechangeAddress' || $route.query.type === 'offLinechangeAddress'"
          class="xiaotishi_style">
          提示:扩展三方面板暂不支持修改设备地址,可通过删除重新添加处理.
        </div>

        <div v-if="$route.query.type === 'onLinechangeRemark' || $route.query.type === 'offLinechangeRemark'"
          class="public_config_que_ren_btn" @click="changeThirdPanelRemarkBtnHandle">确认修改</div>
      </div>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";

export default {
  data() {
    return {
      query: this.$route.query
    };
  },
  components: {
    configHang
  },
  methods: {
    changeThirdPanelRemarkBtnHandle() {
      if (this.query.remark === "") {
        this.$toast("设备备注不能为空！");
        return;
      } else if (this.query.remark.length > 20) {
        this.$toast("修改失败,名称不能超过20个字符哦~");
        return;
      }
      this.$request({
        method: "post",
        url: "/panelExtension/updateThirdPanel",
        data: {
          token: this.$store.state.token,
          panelProductId: this.query.productId,
          remark: this.query.remark
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            return;
          } else {
            this.$showTipsToast(1, "修改成功", true);
            this.$router.go(-2);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.query = this.$route.query;
    console.log(this.query);
  }
};
</script>

<style>
div .add_device_input {
  ime-mode: auto;
}
</style>
